module.exports = __webpack_public_path__ + "img/alert.e9154ba3.svg";